import axios from 'axios'
import { DRIVERAPPLY } from '../../api/url'
const state = {

}

const actions = {
  apply: (context, data) => axios({url: DRIVERAPPLY, method: 'post', data})
}

const getters = {

}

const mutations = {

}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}


// WEBPACK FOOTER //
// ./src/store/modules/driverApplication.js